import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { caseStudies } from '../mockData';
import { Building, DollarSign, TrendingUp } from 'lucide-react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

export default function CaseStudiesSection() {
  const container = useRef();
  const headerRef = useRef();
  const cardsRef = useRef([]);

  useGSAP(() => {
    gsap.from(headerRef.current, {
      opacity: 0,
      y: 40,
      duration: 0.8,
      scrollTrigger: {
        trigger: container.current,
        start: "top 70%",
        end: "top 30%",
        scrub: 0.5,
      }
    });

    cardsRef.current.forEach((card, index) => {
      if (card) {
        gsap.from(card, {
          opacity: 0,
          y: 60,
          scale: 0.95,
          duration: 0.8,
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            end: "top 40%",
            scrub: 0.5,
          }
        });
      }
    });
  }, { scope: container });

  return (
    <section id="case-studies" ref={container} className="section section-dark">
      <div className="section-content">
        <div ref={headerRef} className="section-header">
          <div className="section-eyebrow">Proven Results</div>
          <h2 className="section-title">Client Success Stories</h2>
          <p className="section-description">
            Real outcomes from organizations that partnered with IronQuill to transform their proposal capabilities and win competitive contracts.
          </p>
        </div>

        <div className="case-studies-grid">
          {caseStudies.map((caseStudy, index) => (
            <div 
              key={caseStudy.id}
              ref={(el) => cardsRef.current[index] = el}
              className="case-study-card"
            >
              <div className="case-study-meta">
                <div className="case-study-industry">
                  <Building size={14} style={{ display: 'inline', marginRight: '6px' }} />
                  {caseStudy.industry}
                </div>
                <div className="case-study-value">
                  <DollarSign size={14} style={{ display: 'inline', marginRight: '4px' }} />
                  {caseStudy.value}
                </div>
              </div>

              <h3 className="case-study-client">{caseStudy.client}</h3>

              <div className="case-study-section">
                <div className="case-study-label">Challenge</div>
                <p className="case-study-text">{caseStudy.challenge}</p>
              </div>

              <div className="case-study-section">
                <div className="case-study-label">Solution</div>
                <p className="case-study-text">{caseStudy.solution}</p>
              </div>

              <div className="case-study-section">
                <div className="case-study-label">
                  <TrendingUp size={14} style={{ display: 'inline', marginRight: '6px' }} />
                  Result
                </div>
                <p className="case-study-text">{caseStudy.result}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
